module.exports = __webpack_public_path__ + "img/pc_03.6ac405fb.png";